import { createStyles, rem } from "@mantine/core"

interface UseStylesProps {
    isSelected: boolean
    isDisabled: boolean
}

export const useStyles = createStyles((theme, { isSelected, isDisabled }: UseStylesProps) => {
    return {
        container: {
            display: "flex",
            maxWidth: "15rem",
            padding: "1.25rem",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: rem(4),
            border: `1px solid ${theme.colors.gray[3]}`,
            boxShadow: "0px 4px 8px -4px rgba(0, 0, 0, 0.16)",
            borderColor: isSelected ? theme.colors.green[5] : theme.colors.gray[3],
            background: isSelected && theme.colors.gray[0],
            transition: "border-color 200ms",
            cursor: isDisabled ? "not-allowed" : "pointer",
        },

        icon: {
            width: rem(40),
            height: rem(40),

            margin: "0 auto",
            marginBottom: rem(16),

            backgroundColor: isSelected ? theme.colors.green[1] : theme.colors.violet[1],
            color: isSelected ? theme.colors.green[5] : theme.colors.violet[7],

            borderRadius: rem(20),

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            transition: "background-color 200ms, color 200ms",
        },

        order: {
            marginBottom: 0,

            color: theme.colors.green[8],
            fontSize: theme.fontSizes.sm,
            fontWeight: 500,
        },

        svg: {
            "& svg": {
                fontSize: "1rem",
            },
        },

        title: {
            color: theme.colors.gray[7],
            fontSize: theme.fontSizes.md,
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
        },

        description: {
            textAlign: "center",
            fontSize: theme.fontSizes.sm,
            color: isSelected ? theme.colors.gray[9] : theme.colors.gray[7],
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "150%",
        },
    }
})
